export default "__VITE_ASSET__ByO3fR0m__"